export default __webpack_public_path__ + "e945d2193c4c1f11c80390c30f7d3dbd.webp";